///<amd-module name="typeahead/core/logging/SuggestionEngagementMetric" />

import {TypeaheadMetric} from "typeahead/core/logging/TypeaheadMetric";
import {Suggestion} from "typeahead/core/Suggestion";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export class SuggestionEngagementMetric extends TypeaheadMetric {

    public suggestionShown: boolean;
    public suggestionSelected: boolean;
    public isAddrAutocomplete: boolean;
    public text: string;
    public userTypedQuery: string;
    public selectedSuggestionEssid: string;

    constructor(lob: string, elementId: string, userTypedQuery: string, displayText: string, suggestionShown: boolean,
                selectedSuggestion: Suggestion, activeESSTests: string) {

        super(lob, elementId, "SuggestionEngagement", activeESSTests);

        this.suggestionShown = suggestionShown;
        this.userTypedQuery = userTypedQuery;

        if (selectedSuggestion) {
            this.suggestionSelected = true;
            this.text = selectedSuggestion.getDisplayText();
            this.selectedSuggestionEssid = selectedSuggestion.getSourceName().orElse("-") + ":"
                + selectedSuggestion.getSourceId().orElse("-");
            this.isAddrAutocomplete = selectedSuggestion.isAddrAutoComplete();
        } else {
            this.suggestionSelected = false;
            this.text = displayText;
            this.selectedSuggestionEssid = undefined;
        }
    }
}
